module.exports = __webpack_public_path__ + "media/images/twice-9c331f5aca7c814cc0c4da6f19c27e94.png";